import React from 'react';
import { Link } from 'react-router-dom';
import {ArrowLeft, Clock, MapPin} from 'lucide-react';

const itineraries = [
  {
    title: '3-Day Tokyo Highlights',
    destination: 'Tokyo, Japan',
    days: [
      {
        day: 1,
        title: 'Traditional Tokyo',
        activities: [
          { time: '9:00 AM', place: 'Senso-ji Temple', duration: '2 hours' },
          { time: '11:30 AM', place: 'Nakamise Shopping Street', duration: '1 hour' },
          { time: '1:00 PM', place: 'Lunch in Asakusa', duration: '1 hour' },
          { time: '3:00 PM', place: 'Tokyo Skytree', duration: '2 hours' },
          { time: '6:00 PM', place: 'Dinner in Shibuya', duration: '2 hours' }
        ]
      },
      {
        day: 2,
        title: 'Modern & Pop Culture',
        activities: [
          { time: '9:00 AM', place: 'Meiji Shrine', duration: '1.5 hours' },
          { time: '11:00 AM', place: 'Harajuku Shopping', duration: '2 hours' },
          { time: '2:00 PM', place: 'Shibuya Crossing', duration: '1 hour' },
          { time: '4:00 PM', place: 'TeamLab Borderless', duration: '3 hours' },
          { time: '7:30 PM', place: 'Dinner in Roppongi', duration: '2 hours' }
        ]
      },
      {
        day: 3,
        title: 'Day Trip to Mount Fuji',
        activities: [
          { time: '7:00 AM', place: 'Depart Tokyo', duration: '2.5 hours' },
          { time: '10:00 AM', place: 'Lake Kawaguchi', duration: '2 hours' },
          { time: '1:00 PM', place: 'Lunch with Mt. Fuji view', duration: '1.5 hours' },
          { time: '3:00 PM', place: 'Oshino Hakkai', duration: '1.5 hours' },
          { time: '5:00 PM', place: 'Return to Tokyo', duration: '2.5 hours' }
        ]
      }
    ]
  },
  {
    title: '2-Day Singapore Essentials',
    destination: 'Singapore',
    days: [
      {
        day: 1,
        title: 'Cultural & Gardens',
        activities: [
          { time: '9:00 AM', place: 'Gardens by the Bay', duration: '3 hours' },
          { time: '1:00 PM', place: 'Hawker lunch at Lau Pa Sat', duration: '1 hour' },
          { time: '3:00 PM', place: 'Marina Bay Sands SkyPark', duration: '1.5 hours' },
          { time: '5:30 PM', place: 'Merlion Park', duration: '1 hour' },
          { time: '7:00 PM', place: 'Clarke Quay riverside dining', duration: '2 hours' }
        ]
      },
      {
        day: 2,
        title: 'Heritage & Wildlife',
        activities: [
          { time: '8:00 AM', place: 'Singapore Zoo', duration: '4 hours' },
          { time: '1:00 PM', place: 'Lunch in Little India', duration: '1.5 hours' },
          { time: '3:00 PM', place: 'Chinatown exploration', duration: '2 hours' },
          { time: '6:00 PM', place: 'Sentosa Island', duration: '3 hours' },
          { time: '9:00 PM', place: 'Wings of Time show', duration: '30 mins' }
        ]
      }
    ]
  }
];

export default function Itineraries() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#4A90E2] to-[#5aa0f2] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/guides" className="inline-flex items-center text-gray-100 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Guides
          </Link>
          <h1 className="text-5xl font-bold mb-4">Travel Itineraries</h1>
          <p className="text-xl text-gray-100">Expertly crafted day-by-day plans to maximize your trip</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {itineraries.map((itinerary, idx) => (
          <div key={idx} className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-[#0A2540] mb-2">{itinerary.title}</h2>
              <p className="text-[#FF6B35] text-lg font-medium flex items-center">
                <MapPin className="w-5 h-5 mr-2" />
                {itinerary.destination}
              </p>
            </div>

            {itinerary.days.map((day) => (
              <div key={day.day} className="mb-8 last:mb-0">
                <div className="bg-gradient-to-r from-[#FF6B35] to-[#F7B32B] text-white px-6 py-3 rounded-lg mb-4">
                  <h3 className="text-2xl font-bold">Day {day.day}: {day.title}</h3>
                </div>

                <div className="space-y-4 pl-4">
                  {day.activities.map((activity, i) => (
                    <div key={i} className="flex items-start border-l-4 border-[#4A90E2] pl-6 py-2">
                      <div className="flex-shrink-0 w-24 text-[#0A2540] font-semibold">
                        {activity.time}
                      </div>
                      <div className="flex-1">
                        <div className="font-semibold text-[#0A2540] mb-1">{activity.place}</div>
                        <div className="text-gray-600 text-sm flex items-center">
                          <Clock className="w-4 h-4 mr-1" />
                          {activity.duration}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}